import { mutations } from './mutations';
import { queries } from './queries';

export const requests = {
  mutations,
  queries,
};
